/**
 * @file Applicants.jsx
 * @description Manages new user setup and profile creation
 * 
 * @section Responsibilities
 * - Collect user information
 * - Handle document uploads
 * - Validate profile data
 * - Track onboarding progress
 * 
 * @section Dependencies
 * - Profile Management: User data handling
 * - Document Service: File handling
 * - Validation Service: Data validation
 * 
 * @section Integration Points
 * - Profile API: Data submission
 * - Document Service: File handling
 * - Onboarding Flow: Progress tracking
 * 
 * @section State Management
 * - profileData: User information
 * - validationState: Form validation
 * - progress: Onboarding progress
 * 
 * @section Events
 * - onProfileUpdate: Profile changes
 * - onDocumentUpload: File handling
 * - onValidation: Form validation
 * 
 * @section Props
 * @prop {Object} initialData - Initial profile data
 * @prop {Function} onComplete - Completion callback
 */

import React, { useEffect, useState } from "react";
import Identity from "./Identity";
import Contact from "./Contact";
import Employment from "./Employment";

function Applicants({ sendApplicants }) {
  const emptyData = {
    identity: {},
    contact: {},
    disclosures: {
      isPoliticallyExposed: "NO",
      isControlPerson: "NO",
      isAffiliatedExchangeOrFINRA: "NO",
      // companySymbols: [],
      // firmName: "",
      // politicalExposureDetail: {
      //   politicalOrganization: "None",
      //   immediateFamily: [],
      // },
    },
    employment: {},
    maritalStatus: "",
  };

  const [data, setData] = useState(emptyData);
  const [identity, setIdentity] = useState({});
  const [contact, setContact] = useState({});
  const [employment, setEmployment] = useState({});

  const handleIdentity = (data) => {
    setIdentity(data);
    handleChange("identity", data);
  };

  const handleContact = (data) => {
    setContact(data);
    handleChange("contact", data);
  };

  const handleEmployment = (data) => {
    setEmployment(data);
    handleChange("employment", data);
  };

  const handleChange = (field, value) => {
    setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleNestedChange = (field, subField, value) => {
    setData((prevState) => ({
      ...prevState,
      [field]: {
        ...prevState[field],
        [subField]: value,
      },
    }));
  };

  useEffect(() => {
    sendApplicants(data);
  }, [data]);

  return (
    <>
      <Identity
        sendData={handleIdentity}
        handleChange={handleChange}
        data={data}
      />
      <Contact sendData={handleContact} />
      <p className="subtitle">Employment Information</p>
      <Employment sendData={handleEmployment} />
    </>
  );
}

export default Applicants;
